import axios from "axios";
import moment from "moment";
import { createContext, useCallback, useEffect, useState } from "react";

export const AuthContext = createContext();

function AuthContextProvider({ children }) {
    const [user, setUser] = useState(() => {
        const storageUser = localStorage.getItem("@user");
        return storageUser ? JSON.parse(storageUser) : null;
    });
    const [showAlertDatasLogin, setShowAlertDatasLogin] = useState(false);
    const [messageLogin, setMessageLogin] = useState("");
    const [isExpired, setIsExpired] = useState(false);
    const [cyrcleStorage, setCyrcleStorage] = useState(false);
    const [cycles, setCycles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setCyrcleStorage(JSON.parse(localStorage.getItem("@cycleChosed")));

        const storageCycles = JSON.parse(localStorage.getItem("@ciclysAkatu"));
        if (storageCycles) {
            setCycles(storageCycles);
        }

        const loadStorageData = async () => {
            const storageUser = JSON.parse(localStorage.getItem("@user"));
            if (storageUser) {
                setUser(storageUser);
            }
            setLoading(false);
        };
        loadStorageData();
    }, []);
    useEffect(() => {
        if (isExpired) logoutLogin();
    }, [isExpired]);

    async function getLogin(email, senha, token = null) {
        if (!email) {
            setMessageLogin("E-mail não informado.");
            setShowAlertDatasLogin(true);
            return;
        }

        if (user && user.email && user.email !== email) {
            logoutLogin();
        }

        setShowAlertDatasLogin(false);
        setMessageLogin("");

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/login`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify({
                        email: email,
                        password: senha,
                        token: token,
                    }),
                },
            );

            const data = await response.json();

            if (typeof data.message === "string") {
                setMessageLogin(data.message);
                setShowAlertDatasLogin(true);
                return;
            }

            setShowAlertDatasLogin(false);
            setMessageLogin("");
            localStorage.setItem(
                "@ciclysAkatu",
                JSON.stringify(data.user.cycles),
            );
            setCycles(data.user.cycles);
            localStorage.setItem("loginHour", moment().toISOString());
            localStorage.setItem("@token", data.token.access_token);
            localStorage.setItem("@user", JSON.stringify(data.user));
            localStorage.setItem(
                "@time",
                JSON.stringify(
                    moment().add(3480, "second").format("DD/MM/YYYY H:m:s"),
                ),
            );
            setUser(data.user);

            if (data.user.cycles && data.user.cycles.length > 1) {
                const latestCycle = data.user.cycles.reduce((latest, cycle) => {
                    return parseInt(cycle.cycle) > parseInt(latest.cycle)
                        ? cycle
                        : latest;
                });

                setCyrcleStorage(latestCycle.quiz_id);
                localStorage.setItem(
                    "@cycleChosed",
                    JSON.stringify(latestCycle.quiz_id),
                );
            } else if (data.user.cycles && data.user.cycles.length === 1) {
                setCyrcleStorage(data.user.cycles[0].quiz_id);
                localStorage.setItem(
                    "@cycleChosed",
                    JSON.stringify(data.user.cycles[0].quiz_id),
                );
            }
        } catch (error) {
            console.error("Erro ao fazer login:", error);
            setMessageLogin("Erro ao fazer login. Tente novamente.");
            setShowAlertDatasLogin(true);
            logoutLogin();
        }
    }

    const logoutLogin = useCallback(() => {
        setUser(null);
        localStorage.clear();
    }, []);

    const updateToken = useCallback(async () => {
        const loginHour = localStorage.getItem("loginHour");
        if (!loginHour) return;

        let checkHour = moment(new Date(loginHour)).toNow();

        if (
            Number(checkHour.replace(/[^0-9]/g, "")) < 40 &&
            Number(checkHour.replace(/[^0-9]/g, "")) === 0
        )
            return;
        if (
            checkHour.includes("hora") === false &&
            checkHour.includes("horas") === false
        )
            return;

        const headers = {
            Authorization: `Bearer ${localStorage.getItem("@token")}`,
            Accept: "application/json",
        };

        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/refresh`,
            headers,
        })
            .then((response) => {
                localStorage.setItem("@token", response.data.access_token);
            })
            .catch(() => {
                logoutLogin();
            });
    }, [logoutLogin]);

    const refreshCycles = useCallback(() => {
        const rawCycles = localStorage.getItem("@ciclysAkatu");
        if (rawCycles) {
            setCycles((prev) =>
                JSON.stringify(prev) === rawCycles ? prev : JSON.parse(rawCycles),
            );
        }
    }, []);

    return (
        <AuthContext.Provider
            value={{
                getLogin,
                signed: user !== null,
                cyrcleStorage,
                setCyrcleStorage,
                logoutLogin,
                setIsExpired,
                setUser,
                updateToken,
                showAlertDatasLogin,
                messageLogin,
                loading,
                cycles,
                setCycles,
                refreshCycles,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContextProvider;

